'use client';

import { useSyncExternalStore } from 'react';
import dynamic from 'next/dynamic';

// The button itself needs `useVisualEditingEnvironment` to stay hidden inside
// the Presentation tool, and that hook statically pulls in
// @sanity/visual-editing/react — the whole overlay tree. Loading it through
// `next/dynamic` keeps those bytes in a chunk of their own instead of the
// client bundle every public page downloads.
const DisableDraftModeButton = dynamic(() => import('./DisableDraftModeButton'), { ssr: false });

// Hydration gate as an external store instead of a setState in an effect: the
// server snapshot is `false`, the client one `true`, so the button only renders
// after hydration. Rendering it during the server pass would otherwise leave
// BAILOUT_TO_CLIENT_SIDE_RENDERING markers in the prerendered HTML.
const subscribe = () => () => undefined;
const getSnapshot = (): boolean => true;
const getServerSnapshot = (): boolean => false;

export function DisableDraftMode() {
    const hydrated = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

    if (!hydrated) return null;

    return <DisableDraftModeButton />;
}
